import type { FaireProductEntity } from "../../entity_types/product";

export const p_v4qwb928db: FaireProductEntity = {
  token: "p_v4qwb928db",
  type: "product",
  name: "Keychain - Grateful Dead - Blue Jerry Bear",
  brandToken: "b_q667fpxnjn",
  brandName: "Square Deal Recordings & Supplies",
  imageUrl:
    "https://cdn.faire.com/fastly/0e413695dedb6cd3070a3d3ecdbe5333106888bc1018331d528199f930d2696d.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dd976bcc897257d586b879b363e9e88349d3aa1faca94c880db1f111bb3cc0ac.gif",
    "https://cdn.faire.com/fastly/6ede65e5203dcdc1e592c300671e9888665fe061b7812fafffaf1cbf1e48f516.png",
  ],
  priceDollars: 3.44,
  description:
    "Design: Features the iconic blue Jerry Bear, a beloved symbol of the Grateful Dead, capturing the vibrant and playful spirit of the band. \n\nMaterial: Made from durable rubber, ensuring long-lasting use and vibrant colors. \n\nAttachment: Equipped with a sturdy key ring for secure fastening on keys, bags, or other accessories. \n\nSize: Measures approximately 2.0 inches in height by 1.875 inches in width, making it a perfect size for easy carrying and adding a touch of musical flair to your items. \n\nThis key ring is a fun and functional accessory that brings a touch of the Grateful Dead's legendary style to your collection.",
  tags: [],
  msrpDollars: 6.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:34:11.635Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
